import { inject, Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { $app } from "@app/app.service";

//-- Models --//
import { User } from '@data/model/user.model';
import { Person } from '@data/model/person.model';
import { ConfigService } from '@app/shared/services/config.service';



@Injectable()
export class DataService {

    console: boolean = $app.core.modeDevel;
    logPrefix: string = '@service - ' + this.constructor.name;
    configService = inject(ConfigService);

    getValue(data: any, path: string, errVal: any, deep: boolean = false) {

        if (!data) {
            return errVal;
        }
        else if (!deep) {

            return (data.hasOwnProperty(path)) ? data[path] : errVal;
        }
        else {

            let find = $app.core.code.findPath(data, path);
            // if(this.console)  console.log( this.logPrefix,  'getValue - find', find );

            return (!find.error) ? find.pointer[find.target] : errVal;
        }
    }


    //-- Map by model --//

    mapUser(data: any, mode?: string) {

        let avatar = this.getValue(data, 'filePath', '');
        if (avatar) avatar = this.configService.mediaUrl + avatar + '?ver=' + (Date.now()).toString();

        let element = <User | any>{
            id: this.getValue(data, 'id', 0),
            fullname: (this.getUserFullName(data) || 'Undefined'),
            email: this.getValue(data, 'email', ''),
            avatar: avatar,
            privacyStatementAccepted: this.getValue(data, 'privacyStatementAccepted', false)
        };

        return element;
    }

    mapPerson(data: any, mode?: string) {

        let avatar = this.getValue(data, 'avatar/file_name', '', true);
        if (avatar) avatar = this.configService.mediaUrl + '/' + avatar + '?ver=' + (Date.now()).toString();

        let element = <Person>{
            id: this.getValue(data, 'id', 0),
            fullname: (this.getUserFullName(data) || 'Undefined'),
            email: this.getValue(data, 'email', ''),
            country: this.getValue(data, 'country', ''),
            avatar: avatar,
            title: this.getValue(data, 'title', ''),
            cvExists: !!(this.getValue(data, 'document_id', '')),
            company: this.getValue(data, 'company', '')
        };

        if (mode == 'detail') {

            let dateCreated = this.getValue(data, 'pno_date_created', '');

            element = <Person>{
                yearsInPNO: ((dateCreated) ? $app.core.time.getYearsFormDate(dateCreated) : 0),
                company: this.getValue(data, 'company', ''),
                mobile: this.getValue(data, 'mobile', ''),
                officeLocation: this.getValue(data, 'officeName', ''),
                sectors: this.getValue(data, 'sectors', []),
                services: this.getValue(data, 'services', []),
                grants: this.getValue(data, 'grantProgrammes', []),
                experience: this.getValue(data, 'description', ''),
                linkedin: this.getValue(data, 'linkedin_profile_url', ''),
                ...element
            };
        }

        return element;
    }


    mapPrefilter(data: any, mode?: string) {

        let id = this.getValue(data, 'id', 0);

        let element = <any>{
            id: id,
            name: $app.getListName(mode, id),
            people: this.getValue(data, 'people', 0),
            countries: this.getValue(data, 'country', 0)
        };

        return element;
    }

    mapPersonProject(data: any, mode?: string) {
        let element = <any>{
            id: this.getValue(data, 'id', 0),
            title: this.getValue(data, 'title', '-'),
            responsibles: this.getValue(data, 'responsibles', ['-']),
            submissionYear: this.getValue(data, 'submissionYear', '-'),
            source: 'MATCHPOINT',
            status: this.getValue(data, 'projectStatus/description', '-', true),
            statusId: this.getValue(data, 'projectStatus/id', null, true),
            grantAssociated: this.getValue(data, 'grant/name', '-', true),
            geographicalCoverage: this.getValue(data, 'geograficalCoverage', '-'),
        };

        return element;
    }

    mapPersonClient(data: any, mode?: string) {

        let element = <any>{
            id: this.getValue(data, 'id', 0),
            name: this.getValue(data, 'name', 'Undefined'),
            description: $app.core.code.truncateString(this.getValue(data, 'description', '-'), 300),
            countries: [],
            regions: this.getValue(data, 'regions', []),
            country: null,
            type: this.getValue(data, 'type/name', '-', true),
            sectors: [],
            source: 'MATCHPOINT',
        };

        for (let row of this.getValue(data, 'regions', [])) {
            if (!row.hasOwnProperty('description') && !row.hasOwnProperty('parent'))
                element.country = row.name;
            element.countries.push(row.name);
        }

        for (let row of this.getValue(data, 'sectors', [])) {

            element.sectors.push(row.name);
        }

        return element;
    }

    mapTeamMember(data: any, mode?: string) {

        let avatar = this.getValue(data, 'avatar/file_name', '', true);
        if (avatar) avatar = this.configService.mediaUrl + '/' + avatar + '?ver=' + (Date.now()).toString();

        let element = <any>{
            id: this.getValue(data, 'id', 0),
            fullname: (this.getUserFullName(data) || 'Undefined'),
            title: this.getValue(data, 'title', ''),
            avatar: avatar,
            children: []
        };

        return element;
    }

    //-- Functions --//

    getUserFullName(data: any) {

        let fullname = [];
        let firstName = this.getValue(data, 'first_name', '');
        if (firstName) fullname.push(firstName);
        let lastName = this.getValue(data, 'last_name', '');
        if (lastName) fullname.push(lastName);

        return fullname.join(' ');
    }
}
